const properties = {
	O: {
		value_fr: "Obligatoires",
		value_en: "Mandatory",
	},
	C: {
		value_fr: "Complementaires",
		value_en: "Complementary",
	},
	D: {
		value_fr: "Direct",
		value_en: "Live",
	},
	P: {
		value_fr: "Promotion",
		value_en: "Promotion",
	},
	N: {
		value_fr: "Nouveautés",
		value_en: "New",
	},
	R: {
		value_fr: "Recommandées",
		value_en: "Recommanded",
	},
	H: {
		value_fr: "Hors Modèle",
		value_en: "Out",
	},
	S: {
		value_fr: "Supprimées",
		value_en: "Deleted",
	},
	L: {
		value_fr: "Spécial",
		value_en: "Special",
	},
};



export {properties}



// WEBPACK FOOTER //
// src/modules/stats/core/mappings.js